// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2E36S","notes":"Notes_notes__3qXV-","note":"Notes_note__DP4SX","markdown":"Notes_markdown__2lSsc"};